import React, {FC} from "react";
import cls from "../shop.module.scss";
import Link from "next/link";
import {url} from "../../../services/utils";
import Image from "next/image";
import {ICartItemType} from "../../../types/state";

const ProductImage:FC<{ item: ICartItemType }> = (
    {
        item: {
            product: {
                base_image: { small_image_url: productImgSrc = "" } = {},
                name: productName,
                ...product
            } = {}
        }
    }
) => {
    return (
        <div className={cls["product-image"]}>
            <Link href={url.product(product)} className={cls["product-image__body"]}>
                <a className={cls.cart__link}>
                    <Image
                        src={productImgSrc}
                        alt={productName}
                        placeholder="blur"
                        layout="fill"
                        priority
                        blurDataURL={`/zega/blur1.webp`}
                        objectFit="contain"
                        className={`${cls["product-image__img"]} ${cls["product-small-img"]}`}
                    />
                </a>
            </Link>
        </div>
    )
}

export default ProductImage;
